import { createContext, useContext } from "react";

export type LabelPosition = "above" | "beside";
export type LabelWidth = "sm" | "md" | "lg" | "xl";
/** Only meaningful for the "beside" layout, which is the one with a label column. */
export type LabelAlign = "left" | "right";

interface LabelLayoutValue {
  labelPosition: LabelPosition;
  labelWidth: LabelWidth;
  labelAlign: LabelAlign;
}

const LabelLayoutContext = createContext<LabelLayoutValue>({
  labelPosition: "above",
  labelWidth: "md",
  labelAlign: "right",
});

export const LabelLayoutProvider = LabelLayoutContext.Provider;
export const useLabelLayout = () => useContext(LabelLayoutContext);
